import { Route, BrowserRouter as Router, Routes } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import Blank from "./pages/Blank";
import Calendar from "./pages/Calendar";
import Ecommerce from "./pages/Dashboard/ECommerce";
import FormElements from "./pages/Forms/FormElements";
import NotFound from "./pages/OtherPage/NotFound";
import Success from "./pages/OtherPage/Success";
import Failed from "./pages/OtherPage/Failed";
import BasicTables from "./pages/Tables/BasicTables";
import Alerts from "./pages/UiElements/Alerts";
import Avatars from "./pages/UiElements/Avatars";
import Badges from "./pages/UiElements/Badges";
import Buttons from "./pages/UiElements/Buttons";
import Images from "./pages/UiElements/Images";
import Videos from "./pages/UiElements/Videos";
import UserProfiles from "./pages/UserProfiles";
import AddPlan from "./components/subscription/AddPlan";
import EditPlan from "./components/subscription/EditPlan";
import AllPlans from "./components/subscription/AllPlans";
import SelectPlan from "./components/subscription/SelectPlan";
import PlanRequest from "./components/subscription/PlanRequest";
import AddUserSubscription from "./components/userSubscription/AddUserSubscription";
import EditUserSubscription from "./components/userSubscription/EditUserSubscription";
import AllUserSubscriptions from "./components/userSubscription/AllUserSubscriptions";
import MySubscriptions from "./components/userSubscription/MySubscriptions";
import AddCustomer from "./components/customers/AddCustomer";
import EditCustomer from "./components/customers/EditCustomer";
import AllCustomers from "./components/customers/AllCustomers";
import EditProfile from "./components/profile/EditProfile";
import EditWhatsapp from "./components/settings/EditWhatsapp";
import EditPayments from "./components/settings/EditPayments";
import AllTransactions from "./components/transactions/AllTransactions";

export default function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Dashboard Layout */}
          <Route element={<AppLayout />}>
            <Route index path="/" element={<Ecommerce />} />
            {/* Others Page */}

            <Route path="/subscription/user/add" element={<AddUserSubscription />} />

            <Route path="/subscription/user/edit/:id" element={<EditUserSubscription />} />

            <Route path="/subscription/users/:planId" element={<AllUserSubscriptions />} />

            <Route path="/subscription/add" element={<AddPlan />} />

            <Route path="/subscription/edit/:id" element={<EditPlan />} />

            <Route path="/subscription/all" element={<AllPlans />} />

            <Route path="/customer/add" element={<AddCustomer />} />

            <Route path="/customer/edit/:id" element={<EditCustomer />} />

            <Route path="/customer/all" element={<AllCustomers />} />

            
            <Route path="/subscription/select" element={<SelectPlan />} />

            <Route path="/subscription/self" element={<MySubscriptions />} />

            <Route path="/subscription/request/:id" element={<PlanRequest />} />


            
            <Route path="/transaction/all" element={<AllTransactions />} />



            <Route path="/settings/whatsapp" element={<EditWhatsapp />} />
            
            <Route path="/settings/payments" element={<EditPayments />} />

            <Route path="/profile" element={<EditProfile />} />


            <Route path="/calendar" element={<Calendar />} />
            <Route path="/blank" element={<Blank />} />

            {/* Forms */}
            <Route path="/form-elements" element={<FormElements />} />

            {/* Tables */}
            <Route path="/basic-tables" element={<BasicTables />} />

            {/* Ui Elements */}
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/images" element={<Images />} />
            <Route path="/videos" element={<Videos />} />
          </Route>

          {/* Auth Layout */}
          <Route element={<AuthLayout />}>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
          </Route>

          <Route path="/payment-success-message" element={<Success />} />

          <Route path="/payment-failed-message" element={<Failed />} />

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}
